import AccessDenied from '@/pages/AccessDenied'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(app)/access-denied')({
  component: AccessDeniedPage,
})

function AccessDeniedPage() {
  return <AccessDenied />
}
